module.exports = {
	"0": "0x5b1869D9A4C187F2EAa108f3062412ecf0526b24",
	"1": "0xCfEB869F69431e42cdB54A4F4f105C19C080A601",
	"2": "0xC89Ce4735882C9F0f0FE26686c53074E09B0D550",
	"3": "0x254dffcd3277C0b1660F6d42EFbB754edaBAbC2B",
	"4": "0x9561C133DD8580860B6b7E504bC5Aa500f0f06a7",
	"5": "0xD833215cBcc3f914bD1C9ece3EE7BF8B14f841bb",
	"6": "0xe982E462b094850F12AF94d21D470e21bE9D0E9C",
	"7": "0x59d3631c86BbE35EF041872d502F218A39FBa150",
	"8": "0x0290FB167208Af455bB137780163b7B7a9a10C16",
	"9": "0x9b1f7F645351AF3631a656421eD2e40f2802E6c0",
	"10": "0x67B5656d60a809915323Bf2C40A8bEF15A152e3e",
	"11": "0x2612Af3A521c2df9EAF28422Ca335b04AdF3ac66",
	"12": "0xA57B8a5584442B467b4689F1144D269d096A3daF",
	"13": "0x26b4AFb60d6C903165150C6F0AA14F8016bE4aec",
	"14": "0x630589690929E9cdEFDeF0734717a9eF3Ec7Fcfe",
	"15": "0x0E696947A06550DEf604e82C26fd9E493e576337",
	"16": "0xDb56f2e9369E0D7bD191099125a3f6C370F8ed15",
	"17": "0xa94b7f0465e98609391c623d0560c5720a3f2d33",
	"18": "0xA94B7f0465E98609391C623d0560C5720a3f2D33",
	"19": "0x6eD79Aa1c71FD7BdBC515EfdA3Bd4e26394435cC",
	"20": "0xb09bCc172050fBd4562da8b229Cf3E45Dc3045A6",
	"21": "0xFC628dd79137395F3C9744e33b1c5DE554D94882",
	"22": "0x5f8e26fAcC23FA4cbd87b8d9Dbbd33D5047abDE1",
	"ethernaut": "0xe78A0F7E598Cc8b0Bb87894B0F60dD2a88d6a8Ab"
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/deploy.local.json
// module id = 1521
// module chunks = 0